import React from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "../ui/button";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import useLayoutTickets from "../../hooks/useLayoutTickets";

const TicketHeader = ({ loading, children }) => {
  const navigate = useNavigate();
  const layout = useLayoutTickets();
  const handleBack = () => {
    navigate("/tickets");
  };

  if (loading) {
    return <TicketHeaderSkeleton />;
  }

  return (
    // No celular as ações não cabem ao lado do nome: com atendimento aberto
    // são sete controles, e o nome do contato era espremido até virar "E..".
    // Com o flex-wrap elas descem para uma segunda linha — custa uns 40px de
    // altura e devolve o nome inteiro, em vez de esconder botão.
    <div className="flex flex-none flex-wrap items-center gap-x-2 gap-y-1.5 border-b bg-background px-3 py-2 shadow-xs">
      <Button
        variant="ghost"
        size="icon"
        onClick={handleBack}
        // No layout Foco a lista não está na tela em largura nenhuma: o
        // caminho de volta some junto se o botão continuar só no celular.
        className={layout === "foco" ? "shrink-0" : "shrink-0 lg:hidden"}
        aria-label="Voltar para a lista"
        title="Voltar para a lista (Esc)"
      >
        <ChevronLeft className="h-5 w-5" />
      </Button>
      {children}
    </div>
  );
};

export default TicketHeader;
